<template>
  <div class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">导入废弃单</span>
    </div>
    <div v-if="!show_success" class="mt50">
      <Form :model="formItem" :label-width="130">
        <FormItem label="客户编号">
          <span class="ml10">{{client_name_code}}</span>
          <!-- <input class="w300 ivu-input ivu-input-default" v-model="formItem.client_code" /> -->
        </FormItem>
        <FormItem label="选择文件" style="margin-bottom: 5px;">
          <input class="w300 ivu-input ivu-input-default" v-model="selectTxt" />
          <button class="ivu-btn ivu-btn-primary" @click="triggerFile">浏览文件</button>
        </FormItem>
        <FormItem label="">
          <a @click="download" class="blue">下载Excel模板文件</a>
        </FormItem>
        <FormItem label="">
          <button class="ivu-btn ivu-btn-primary" @click="upData">上传文件</button>
        </FormItem>
      </Form>
    </div>

    <div v-if="show_success" class="export-success mt50">
      <p class="mt20">以下为导入结果：</p>
      <Table class="mt20" border :columns="columns" :data="list">
      </Table>
      <div class="mt30 tr">
        <button v-if="!had_error" class="ivu-btn ivu-btn-primary" @click="confirmUp">
          确定创建废弃单
        </button>
        <button class="ivu-btn ivu-btn-primary" @click="show_success=false">重新上传</button>
      </div>
    </div>

    <form id="uploadForm" style="display: none;">
      <input type="file" id="file" @change="uploadFile">
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        client_name_code: '',
        client_code: '',
        import_id: [],
        list: [],
        columns: [{
          title: 'SKU',
          key: 'o_fnsku',
          tooltip: true,
          width: 150,
        },  {
          title: '数量',
          key: 'product_count',
          tooltip: true,
          width: 100,
        }, {
          title: '导入结果',
          tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: {
                cursor: "pointer",
                color: params.row.success ? "green" : 'red'
              },
            }, params.row.success ? '成功' : params.row.message)
          }
        }],
        formItem: {},
        fileData: '',
        selectTxt: '',
        show_success: false,
        had_error: false, //是否有错误
        had_success:false,
      }
    },
    methods: {
      triggerFile() {
        $('#file').trigger('click')
      },
      download() {
        this.$axios.get("/WarehouseDiscard/bill/import/excel/template?biz_type=3").then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      uploadFile(event) { //上传文件
        let _file = event.target.files[0];
        this.fileData = _file;
        this.selectTxt = _file.name;
      },
      upData() { //确定上传
        if (!this.client_code) {
          this.$Message.error('请选择子账号');
          return false;
        }
        if (!this.selectTxt) {
          this.$Message.error('请上传文件');
          return
        }
        let formData = new FormData();
        formData.append('file', this.fileData);
        this.$axios.post('/WarehouseDiscard/bill/import?biz_type=3&warehouse_id=' + localStorage.getItem('warehouse_id') +
          '&client_code=' + this.client_code, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((data) => {

            this.had_error = false;
          if (data.success) {
            this.$Message.success("上传成功");
            this.fileData = "";
            this.selectTxt = "";
            this.show_success = true;
            this.list = data.data;
            if (data.data && data.data.length) {
              data.data.forEach(item => {
                if (!item.success) {
                  this.had_error = true;
                }
              })
              this.import_id = data.data[0].import_id
            }
            document.getElementById("uploadForm") && document.getElementById("uploadForm").reset(); //清除input
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      confirmUp() {
        if (!this.import_id) {
          this.$Message.error('请重新上传文件');
          return
        }
        this.$axios.post('/WarehouseDiscard/bill/import/confirm?import_id=' + this.import_id).then((data) => {
          if (data.success) {
           this.$router.push({
             path: '/prep/discard'
           })
           this.$Message.success('创建成功');
          }
        })
      },
      reupload() {
        window.location.reload()
      }
    },
    created() {
      this.client_name_code = localStorage.getItem('client_name_code') || ''
      this.client_code = localStorage.getItem('client_code') || ''
      if (!this.client_code) {
        this.$Message.info('请选择子账户');
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/prep/discard/import.vue